import { BLOCK_EXPLORER_TXN_ID_URL } from '../../utils/config';
import { trimString } from '../../utils/converter';

export const ReportHeading = ({ reportData }) => {
  return (
    <div className="text-lg sm:text-xl md:text-2xl break-words">
      {reportData.TOKEN_ID ? (
        <>
          {`Report ID: `}
          <a
            href={`${BLOCK_EXPLORER_TXN_ID_URL}/${reportData.TOKEN_TXPOW}`}
            target="_blank"
            className="text-orange cursor-pointer break-all hover:underline"
          >
            {trimString(reportData.TOKEN_ID)}
          </a>
        </>
      ) : (
        'Report generated without trace'
      )}
    </div>
  );
};
